import { inject, Injectable } from "@angular/core";
import { ApiService } from "@services/api.service";
import { EndPoints } from "@services/EndPoints";

//INTERFAZ PARA LA RESPUESTA DE DEFAULT TAXES
export interface DefaultTaxesDto {
  vat: string;
  pit: string;
}

//INTERFAZ PARA LA RESPUESTA DE ACTUALIZACIÓN
export interface UpdateDefaultTaxesResponseDto {
  message: string;
}

@Injectable({ providedIn: 'root' })
export class ConfigProvider {

  private readonly api = inject(ApiService);

  /**
   * OBTENER LOS IMPUESTOS POR DEFECTO (IVA/IRPF)
   * @returns IMPUESTOS POR DEFECTO
   */
  async getDefaultTaxes(): Promise<DefaultTaxesDto | null> {
    try {
      return await this.api.get<DefaultTaxesDto>({
        url: EndPoints.getDefaultTaxes
      });
    } catch (error) {
      console.error('Error al obtener impuestos por defecto:', error);
      return null;
    }
  }

  /**
   * ACTUALIZAR LOS IMPUESTOS POR DEFECTO (IVA/IRPF)
   * @param vat - VALOR DEL IVA (SIN EL SÍMBOLO %)
   * @param pit - VALOR DEL IRPF (SIN EL SÍMBOLO %)
   * @returns RESPUESTA DE ACTUALIZACIÓN
   */
  async updateDefaultTaxes(vat: string, pit: string): Promise<UpdateDefaultTaxesResponseDto | null> {
    try {
      return await this.api.post<UpdateDefaultTaxesResponseDto>({
        url: EndPoints.updateDefaultTaxes,
        body: {
          vat: vat,
          pit: pit
        }
      });
    } catch (error) {
      console.error('Error al actualizar impuestos por defecto:', error);
      return null;
    }
  }
}
